import { render, staticRenderFns } from "./summaryApiBarChart.vue?vue&type=template&id=1db834c1&scoped=true"
import script from "./summaryApiBarChart.vue?vue&type=script&lang=js"
export * from "./summaryApiBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db834c1",
  null
  
)

export default component.exports